export const sizeItemOnPage = 7;

export const adminsTitle = [
    "type-of-account",
    "full-name",
    "phone",
    "email",
    "city",
];
